import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
    height: '600px',
    width: '800px',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '0.9rem',
    color: theme.colors.eyConfidentGrey,
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '0.9rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  actionsRoot: {
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '1000px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
  closeIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
});

class DocumentPreviewDialog extends React.Component {
  static propTypes = {};
  render() {
    const { children, classes, open, onCancel, title } = this.props;

    return (
      <Dialog classes={{ root: classes.root, paper: classes.rootPaper }} open={open} maxWidth={'xl'}>
        <div className={classes.header}>
          <h2 className={classes.title} id="confirm-title">
            {title}
          </h2>
          <div className={classes.closeIcon} onClick={onCancel || null}>
            <CloseIcon />
          </div>
        </div>
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText classes={{ root: classes.contentText }} style={{ height: '95%' }}>
            {children}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DocumentPreviewDialog);
